import axios from 'axios';
import {HttpUtils} from "./common/HttpUtils";

export { PartsSearchService };

function PartsSearchService(auth, error) {

    this.jwt = auth.jwt;
    this.sessionId = auth.sessionId;
    this.partsBaseUrl = `${process.env.VUE_APP_API_URL}/v1/catalog/parts`;
    this.headers = HttpUtils.getHttpHeaders(auth, 'text/json');

    if (!error){
        console.error(error);
    }
    else {
        this.error = error;
    }
}


PartsSearchService.prototype.getPartSummary = function(partNumber, data, notFound, error)  {

    let url = `${this.partsBaseUrl}/${partNumber}/summary`;

    axios.get(url, {headers: this.headers}).then(response => {
        data(response.data);
    }).catch((e) => {
        this.internalProcessHttpError(e, notFound, error);
    });

};


PartsSearchService.prototype.internalProcessHttpError = function(e, notFound, error){

    if (e.response) {
        if (e.response.status === 404) {
            if (notFound) {
                notFound(e.response.data);
            }
        } else {
            if (this.error) {
                this.error(e.response.status, e.response.data);
            }

            if (error) {
                error(e.response.status, e.response.data);
            }
        }
    }

    console.error(e);
};

